import { inject, Injectable } from '@angular/core';
import { combineLatest, startWith, switchMap, tap } from 'rxjs';

import { ChangeOrderStatus, EventType, GqlService } from '@shared/services/gql.service';
import { EventService } from '@shared/store/event/event.service';
import { MainQuery } from '@shared/store/main/main.query';
import { MainStore } from '@shared/store/main/main.store';

@Injectable()
export class NavigationMenuService {
  private eventService = inject(EventService);
  private gqlService = inject(GqlService);
  private mainQuery = inject(MainQuery);
  private mainStore = inject(MainStore);

  getNumberOfCOsInPendingApproval() {
    return combineLatest([
      this.mainQuery.select('trialKey'),
      this.eventService
        .select$(EventType.NUMBER_OF_PENDING_APPROVAL_COS_UPDATED)
        .pipe(startWith(null)),
    ]).pipe(
      switchMap(() => this.gqlService.listChangeOrdersStatuses$()),
      tap((COs) => {
        const numberOfCOsInPendingApproval =
          COs.data?.filter(
            (co) => co.change_order_status === ChangeOrderStatus.STATUS_PENDING_APPROVAL
          ).length || 0;

        this.mainStore.update({ numberOfCOsInPendingApproval });
      })
    );
  }
}
